import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SubmenuModel } from '../models/submenu.model';

@Injectable({
  providedIn: 'root',
})
export class SubmenuService {
  private _backText: string = 'Back to home';
  private _backPath: string = '/dashboard';

  constructor(private _router: Router) {}

  get backText(): string {
    return this._backText;
  }

  set backText(value: string) {
    this._backText = value;
  }

  get backPath(): string {
    return this._backPath;
  }

  set backPath(value: string) {
    this._backPath = value;
  }

  isSubmenuNeeded(serviceTabs: SubmenuModel): boolean {
    const isPrivateUrl = this._router.url.includes('/private');
    const existPublicTabs = serviceTabs.publicService ? serviceTabs.publicService.tabs.length > 0 : false;
    const existPrivateTabs = serviceTabs.privateService ? serviceTabs.privateService.tabs.length > 0 : false;

    // Is Submenu needed?
    const needSubmenu = (isPrivateUrl && existPrivateTabs) || (!isPrivateUrl && existPublicTabs);
    return needSubmenu;
  }

  updateBackLink(text: string, path: string): void {
    this._backText = text;
    this._backPath = path;
  }
}
